export default function navigationMobileDrawer() {
  let getHeight = document.querySelector('.cm4all-theme-header')?.offsetHeight;
  const setHeight = document.querySelector(
    '.cm4all-theme-navigation-mobile-drawer'
  );
  const NAV_ITEMS_WRAPPER = document.querySelector(
    '.cm4all-theme-navigation-mobile-drawer__menu'
  );

  if (document.body.classList.contains('admin-bar')) {
    getHeight += 32;
  }

  if (setHeight) {
    setHeight.style.paddingTop = `${getHeight}px`;
  }

  if (NAV_ITEMS_WRAPPER) {
    NAV_ITEMS_WRAPPER.style.height = `calc(100vh - ${getHeight}px)`;
  }
}
